import { createContext } from 'react';
import Auth, { AuthState } from './auth';

const defaultContext: [AuthState, ((user: AuthState) => void) | null] = [Auth.loggedOut(), null];

const AccessTokenContext = createContext(defaultContext);

export default AccessTokenContext;
